import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { ReflexEnvironment as ENV } from '@smartsoftware/reflex-core';
// import { ResourceService } from "@smartsoftware/reflex-core";
// import { SuccessCase } from "../models/successCase.model";
// import { SuccessCaseContact } from "../models/successCaseContact.model";
// import { BehaviorSubject, Observable } from "rxjs";
import { map, tap } from "rxjs/operators";
import { Attorney } from '../models';
// import { SuccessAccount } from "../models/successAccount.model";
// import { Page, PageParams, Pager } from '../paged.datasource';

@Injectable()
export class LegalConnect_Service {

    constructor(
        protected http: HttpClient
    ) {}

    private updateCustomerAccount(customerNumber: string, companyNumber: number) : Promise<any>{
        return this
            .http
            .post(
                ENV.config['openapiUrl'] +`/LegalConnect/customerAccount`,
                {
                    customerNumber: customerNumber,
                    companyNumber: companyNumber
                },
                {
                    observe: 'response'
                }
            )
            .pipe(
                map(
                    (response: HttpResponse<any>) =>
                        response.body
                )
            )
            .toPromise();
    }
    
    private updateUserAccount(email: string) {
        return this
            .http
            .post(
                ENV.config['openapiUrl'] +`/LegalConnect/userAccount`,
                {
                    emailAddress: email
                },
                {
                    observe: 'response'
                }
            )
            .pipe(
                map(
                    (response: HttpResponse<any>) =>
                        response.body
                )
            )
            .toPromise();
    }

    private loginUser(email: string) {
        return this
            .http
            .post(
                ENV.config['openapiUrl'] +`/LegalConnect/login`,
                {
                    email: email
                },
                {
                    observe: 'response'
                }
            )
            .pipe(
                map(
                    (response: HttpResponse<any>) =>
                        response.body
                )
            )
            .toPromise();
    }

    private requestLoginCookie(cookieUrl: string) {
        return this
            .http
            .get(
                cookieUrl, 
                {
                    observe: 'response',
                    responseType: 'text',
                    withCredentials: true
                }
            )
            .pipe(
                map(
                    (response: HttpResponse<any>) => 
                        response.body
                )
            )
            .toPromise();
    }

    public getLCAttorneys(customerNumber: string, companyNumber: number) {
        return this
            .http
            .get(
                ENV.config['openapiUrl'] 
                + `/Attorney/attorneyList?customerNumber=${customerNumber}&companyNumber=${companyNumber}`,
                {
                    observe: 'response'
                }
            )
            .pipe(
                map(
                    (response: HttpResponse<any>) => 
                        response.body
                )
            );
    } 

    private createAttorney(clientBranch: string, addressBook: string, email:string, barId: number, customerNumber: string, companyNumber: number, successAccount: string | null) {
        return this
            .http
            .post(
                ENV.config['openapiUrl'] + `/Attorney/attorney`, 
                {
                    "clientBranch_uuid": clientBranch, 
                    "addressBook_uuid": addressBook,
                    "emailAddress": email,
                    "barId": barId,
                    "companyNumber": companyNumber, 
                    "customerNumber": customerNumber,
                    "successAccount_uuid": successAccount
                },
                {
                    observe: 'response'
                }
            )
            .pipe(
                map(
                    (response: HttpResponse<any>) =>
                        response.body as Attorney
                )
            )
            .toPromise();
    }

    public async updateLCCustomerAccount(customerNumber: string, companyNumber: number) : Promise<any> {
        let response = await this.updateCustomerAccount(customerNumber, companyNumber);
        
        console.debug('LC update customer account', response);
        
        if(!response.success) return Promise.resolve({success:false, result:response});
        
        return Promise.resolve({success:true, result:response});
    } 

    public async updateLCUserAccount(email: string) : Promise<any> {
        let response = await this.updateUserAccount(email);
        
        console.debug('LC update user account', response);
        
        if(!response.success) return Promise.resolve({success:false, result:response});
        
        return Promise.resolve({success:true, result:response});
    }

    public async loginLCUser(email: string) : Promise<LCResponse> {
        let response = await this.loginUser(email);
        
        console.log('LC login', response);
        
        if(!response.cookieUrl) return Promise.resolve({success:false, result: undefined});
        
        return Promise.resolve({success:true, result:response});
    }

    public async requestLCLoginCookie(cookieUrl: string) : Promise<any> {
        let response = await this.requestLoginCookie(cookieUrl);

        console.log('LC cookie', response);
        
        // if(!response.success) return Promise.resolve(false);
        
        return Promise.resolve(response);
    }

    // public async getLCAttorneys(customerNumber: string, companyNumber: number) : Promise<boolean> {
    //     let response = await this.getAttorneys(customerNumber, companyNumber);
        
    //     console.log('LC attorneys', response);
        
    //     if(!response || !response.length) return Promise.resolve(false);
        
    //     return Promise.resolve(true);
    // }

    public async createLCAttorney(clientBranch: string, addressBook: string, email:string, barId: number, customerNumber: string, companyNumber: number, successAccount: string | null) : Promise<Attorney> {
        let response = await this.createAttorney(clientBranch, addressBook, email, barId, customerNumber, companyNumber, successAccount);
        
        console.log('LC create Attorney', response);
        
        if(!response) return Promise.reject("Could not create attorney");
        
        return Promise.resolve(response);
    }
}

export interface LCResponse {
    success: boolean,
    result: any
}

interface LCAttorney {
    id: number,
    emailAddress?: string,
    fullName?: string,
    barId?: number,
    gfAccountId?: string | null,
    companyNo?: number,
    customerNo?: string,
    lcAccountNumber?: number
}
